<input type="hidden" [(ngModel)]="value" />
<mat-error *ngIf="!valid">
    {{errorMessage}}
</mat-error>